import { action, observable } from 'mobx';

export default class UIStore {
	PER_PAGE = 10;
	@observable page = null;
	@observable menuVisible = false;
	@observable showDevConfig = false;
	@observable notification = false;

	MAXIMUM_ARTICLES_ON_MAINPAGE = 10;

	constructor(store) {
		this.store = store;
	}

	@action setPage = pageName => {
		this.page = pageName;
	};

	@action setNotification = notification => {
		if (notification) {
			const { message, error } = notification;
			this.notification = { message, error };
		} else {
			this.notification = false;
		}
	};
}
